import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import { Card } from '@material-ui/core';
import { colors } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List'; 
import ListItem from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { mainListItems, secondaryListItems } from '../listItems';
import { useSelector, useDispatch } from "react-redux"
import { Button } from '@material-ui/core'; 
import logo5 from "../../logo5.png"; 
import RehabPlanMainComponent from '../data/overview_data.js/RehabPlanMainComponent';
import Treatmentadvices from '../data/treatmentadvice/Treatmentadvice.js';
import recoveryPhases from '../../user_dashboard/data/recoveryPhases';
import * as AuthActions from "../../../store/actions/auth";
import ReactPlayer from 'react-player';
import RehabPhases from "../data/rehabPhases.js";
import HorizontalScroll from 'react-horizontal-scrolling';
import Skeleton from '@material-ui/lab/Skeleton';
import VideoPlayer from "./videoPlayer";
import NextExercises from "./nextExersices";
//import FeedbackComp from "./feedback";
import FeedbackCompPopOver from "./popoverFeedback";
import FeedbackDialog from "./dialogbox";
import LinearProgress from "@material-ui/core/LinearProgress";
import WeeklyGoal from '../data/overview_data.js/WeeklyGoal';
import CompletedExercises from './completedExersices';
import CurrentSessionTracker from "../data/overview_data.js/CurrentSessionTracker";
import VideoTutorial from "./YTtutorial";
import RehabPhaseTracker from '../data/overview_data.js/RehabPhaseTracker';
import screenfull from "screenfull";
import FlagExerciseForReview from './flagExercise';
import HowItWorksAccordion from "./accordionHowItWorks";
import DateRangeIcon from '@material-ui/icons/DateRange';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import DiscreteSlider from "./rehabPhaseProgressBar";
import WelcomeScreen from "./welcomeScreen";
import ExerciseIntro from "./exerciseHelpIntroduction";
import CompletedSessionPartly from "./completedSessionPartly";
import CompletedSession from './completedSession';
import SessionSummary from './SessionSummary';


const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
  },
  avatar: {
    backgroundColor: colors.orange[600],
    height: 50,
    width: 50
  },
  sidebarGrid: {
    marginTop: 0,
    overflowY: 'hidden',
    paddingLeft: 'clamp(8px, 1.2vw, 16px)',
    paddingRight: 'clamp(4px, 0.6vw, 8px)',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
}));


const TreatmentSessionPlayer = (props) => {
  const className = props.className
  const [allowedSessions, setAllowedSessions] = useState(1);
  const [sessionsToday, setSessionsToday] = useState(0);
  const classes = useStyles();
  const [feedbackRef, setFeedbackRef] = useState()
  const [educationRef, setEducationRef] = useState()
  const containerRef = React.useRef()
  const playerRef = React.useRef()
  const [videoIsPlaying, setVideoIsPlaying] = useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handlePlayPause = () => setVideoIsPlaying(isPlaying => !isPlaying);
  const [videoDuration, setVideoDuration] = React.useState(null);

  const [phaseData, setPhaseData] = useState({
    progress: "?",
    title: "?",
    progressDisplay: null,
  })

  const [diagnosis, setDiagnosis] = useState({
    title: "",
    explainer: "",
    identifier: ""
  }) // Placeholder
  const { innerWidth: width, innerHeight: height } = window;

  const [token, _] = useState(useSelector(state => state.auth.token))
  const [exercises, setExercises] = useState([])
  const [current_exercise_ind, setCurrent_exercise_ind] = useState(0)
  const externalExerciseCacheRef = React.useRef({});
  const initializedTreatmentIdRef = React.useRef(null);
  const [equipmentList, setEquipmentList] = useState([]);
  //feedback, start or video
  const [playingState, setPlayingState] = useState("welcome")
  const [allDailySessionsComplete, setAllDailySessionsComplete] = useState();
  const [allDailySessionsPartlyCompleted, setAllDailySessionsPartlyCompleted] = useState();
  const [first_today, setFirst_today] = useState();
  const [sessionId, setSessionId] = useState(null);
  const [treatmentIdState, setTreatmentIdState] = useState(null);
  const treatmentIdProp = props.treatmentId; // from parent
  const [sessionFeedbackRequired, setSessionFeedbackRequired] = useState(false);
  const [expectedExerciseLength, setExpectedExerciseLength] = useState(null);
  // Map of exercise identifier -> ExerciseFeedback row id, populated as the
  // patient submits per-exercise feedback. Forwarded to SessionSummary so each
  // card can PATCH its own row when the patient corrects partial completion.
  const [feedbackIds, setFeedbackIds] = useState({});
  const recordFeedbackId = React.useCallback((exerciseIdentifier, feedbackId) => {
    if (!exerciseIdentifier || !feedbackId) return;
    setFeedbackIds(prev => ({ ...prev, [exerciseIdentifier]: feedbackId }));
  }, []);
  const [completedSessionsList, setCompletedSessionsList] = useState([]);
  // aggregated sessions (all historical) used to compute overall/7-day compliance
  const [completedSessionsAll, setCompletedSessionsAll] = useState([]);
  const [avgCompliance, setAvgCompliance] = useState(null);
  const [avgAdherenceLast7, setAvgAdherenceLast7] = useState(null);
  const completedSessionsTodayWithFeedback = completedSessionsAll.filter(session => {
    if (!session.completed_date || !(session.exercise_feedback || []).length) return false;
    const completedAt = new Date(session.completed_date);
    const today = new Date();
    return completedAt.toDateString() === today.toDateString();
  });
  
  // Inactivity timeout refs and state
  const inactivityTimeoutRef = React.useRef(null);
  const lastActivityRef = React.useRef(Date.now());

  // Reset inactivity timer on user activity
  const resetInactivityTimer = () => {
    lastActivityRef.current = Date.now();
    if (inactivityTimeoutRef.current) {
      clearTimeout(inactivityTimeoutRef.current);
    }
    inactivityTimeoutRef.current = setTimeout(() => {
      console.warn('[SESSION] 15-minute inactivity timeout reached, ending session');
      endSessionDueToInactivity();
    }, 15 * 60 * 1000); // 15 minutes
  };

  // End session due to inactivity
  const endSessionDueToInactivity = async () => {
    if (sessionId && token) {
      try {
        console.log('[SESSION] Ending session due to inactivity:', sessionId);
        // POST to feedback endpoint to complete the session
        const response = await fetch(`https://api.virtus-one.com/treatment/feedback/submit`, {
          method: 'POST',
          headers: {
            "Authorization": `Token ${token}`,
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            session_id: sessionId,
            exercise_feedback: [],
            session_feedback: {
              like_status: "skipped",
              feedback: "Session ended due to inactivity timeout"
            }
          })
        });
        if (response.ok) {
          console.log('[SESSION] Session ended successfully due to inactivity');
          setSessionId(null);
          setPlayingState('welcome');
        } else {
          console.error('[SESSION] Failed to end session, status:', response.status);
        }
      } catch (err) {
        console.error('[SESSION] Error ending session:', err);
        // Still clear session even if endpoint fails
        setSessionId(null);
        setPlayingState('welcome');
      }
    }
  };

  // Setup inactivity timer on session start
  React.useEffect(() => {
    if (sessionId) {
      console.log('[SESSION] Session started, inactivity timer initialized (15 min timeout)');
      resetInactivityTimer();
      const activityListener = () => resetInactivityTimer();
      window.addEventListener('mousemove', activityListener);
      window.addEventListener('keypress', activityListener);
      window.addEventListener('click', activityListener);
      
      return () => {
        clearTimeout(inactivityTimeoutRef.current);
        window.removeEventListener('mousemove', activityListener);
        window.removeEventListener('keypress', activityListener);
        window.removeEventListener('click', activityListener);
      };
    }
  }, [sessionId, token]);

  const simpleFormatter = (text, len) => {
    var i = 0;
    for (i = 0; i < text.length; i = i + len) {
      if (i != 0) {
        const subString = text.slice(0, i).split("").reverse().join(""); // abc d -> d cba
        const splitIndex = subString.length - subString.indexOf(' ');
        text = text.slice(0, splitIndex) + "\n" + text.slice(splitIndex);
      }
    }
    return text;
  }

  // debugging starts here
//  const fetchDiagnosisData = async () => {
//  setIsFetching(true);
//  const response = await fetch(`https://api.virtus-one.com/treatment/all_diagnosis/${userId}/`, {
//    headers: {
//      "Authorization": `Token ${token}`
//    },
//    method: "GET"
//  });
//
//  if (response.ok) {
//    const data = await response.json();
//    console.log("User-specific diagnosis:", data);
//    const diagnosisSlug = data[0].diagnosis.diagnosis;  // Or .identifier depending on your schema
//    setDiagnosis({ ...data[0].diagnosis });
//    fetchExercises(diagnosisSlug);
//    fetchPhaseData(diagnosisSlug);
//  } else {
//    alert("Failed to fetch diagnosis for user.");
//  }
//
//  setIsFetching(false);
//};
  const fetchDiagnosisData = async () => {
    const treatmentId = treatmentIdProp || treatmentIdState;
    if (!treatmentId) {
      console.log('[TreatmentSessionPlayer] No treatmentId available, skipping fetch');
      return;
    }
    fetchExercises('', treatmentId);
  }
  
  const fetchExercises = async (diagnosisIdentifier, treatmentId) => {
    const tid = treatmentId || treatmentIdProp || treatmentIdState;
    console.log("Then me")
    console.log('[TreatmentSessionPlayer] Fetching exercises for treatment:', tid);
    
    if (tid) {
      // Use treatment-based endpoint
      const response = await fetch(`https://api.virtus-one.com/treatment/session/today/treatment/${tid}/`, {
        headers: {
          "Authorization": `Token ${token}`
        },
        method: "GET",
      });

      if (response.ok) {
        const data = await response.json();
        // console.log('[TreatmentSessionPlayer] Today session data:', data);
        setExercises(data.exercises);
        setDiagnosis({
          title: data.diagnosis_title || '',
          explainer: data.diagnosis_explainer || '',
          identifier: data.diagnosis_identifier || '',
        });
        setPhaseData({
          progress: data.phase_progress ?? '?',
          title: data.phase_title || '?',
          progressDisplay: data.phase_progress_display || null,
        });
        const equipment = Array.from(new Set(data.exercises.map(ex => ex.equipment).filter(Boolean)));
        setEquipmentList(equipment);
        // console.log("equipment", equipment)
        setSessionId(data.session_id);
        setExpectedExerciseLength(data.expected_exercise_length ?? (Array.isArray(data.exercises) ? data.exercises.length : null));
        // console.log(data.exercises)
        // console.log("Progress:", data["progress"])
        setCurrent_exercise_ind(data["progress"])
        setAllowedSessions(data.allowed_sessions);
        setSessionsToday(data.sessions_today);
        setSessionFeedbackRequired(data.sessionFeedbackRequired);
        setAllDailySessionsComplete(data.allDailySessionsComplete);
        setAllDailySessionsPartlyCompleted(data.allDailySessionsPartlyCompleted);
        setFirst_today(data.first_today);
        setCompletedSessionsList(data.completed_sessions_today || []);
        setTreatmentIdState(tid);
        return data;
      } else {
        const errorText = await response.text();
        console.error('[TreatmentSessionPlayer] Error fetching exercises:', response.status, errorText);
        alert("ERROR LOADING SESSION");
      }
    } else {
      // Fallback to diagnosis-based (backward compatibility)
      // console.log("Fetching exercises from:", "https://api.virtus-one.com/treatment/session/today/" + diagnosisIdentifier);
      const response = await fetch("https://api.virtus-one.com/treatment/session/today/" + diagnosisIdentifier, {
        headers: {
          "Authorization": `Token ${token}`
        },
        method: "GET",
      });

      if (response.ok) {
        const data = await response.json();
        setExercises(data.exercises);
        const equipment = Array.from(new Set(data.exercises.map(ex => ex.equipment).filter(Boolean)));
        setEquipmentList(equipment);
        // console.log("equipment", equipment)
        setSessionId(data.session_id);
        setExpectedExerciseLength(data.expected_exercise_length ?? (Array.isArray(data.exercises) ? data.exercises.length : null));
        // console.log(data.exercises)
        // console.log("Progress:", data["progress"])
        setCurrent_exercise_ind(data["progress"])
        setAllowedSessions(data.allowed_sessions);
        setSessionsToday(data.sessions_today);
        setSessionFeedbackRequired(data.sessionFeedbackRequired);
        setAllDailySessionsComplete(data.allDailySessionsComplete);
        setAllDailySessionsPartlyCompleted(data.allDailySessionsPartlyCompleted);
        setFirst_today(data.first_today);
        setCompletedSessionsList(data.completed_sessions_today || []);
        // Best-effort: backend responses may include treatment_id in some flows; store if present
        if (data && data.treatment_id) { try { setTreatmentIdState(data.treatment_id); } catch(e) {} }
        return data;
      } else {
        const errorText = await response.text();
        alert("ERROR: " + errorText);
        return null;
      }
    }
  }

  const handleStateShift = (newState) => {
    console.log(newState)
    setPlayingState(newState)
  }

  // Explicitly start a new session on user action (frontend must request creation)
  const startSession = async () => {
    try {
      const res = await fetch("https://api.virtus-one.com/treatment/session/start/", {
        method: "POST",
        headers: {
          "Authorization": `Token ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ diagnosis: diagnosis.identifier })
      });
      if (!res.ok) {
        const txt = await res.text();
        alert("Failed to start session: " + txt);
        return;
      }
      const data = await res.json();
      setSessionId(data.session_id);
      if (data && data.treatment_id) { try { setTreatmentIdState(data.treatment_id); } catch(e) {} }
      if (data.exercises) {
        setExercises(currentExercises => data.exercises.map(exercise => {
          const existingExercise = currentExercises.find(currentExercise => (
            currentExercise.identifier === exercise.identifier
            || (
              currentExercise.source === exercise.source
              && String(currentExercise.sourceExerciseId) === String(exercise.sourceExerciseId)
            )
          ));
          return {
            ...exercise,
            img: exercise.img || existingExercise?.img,
            video: exercise.video || existingExercise?.video,
            description: exercise.description || existingExercise?.description,
            instructions: exercise.instructions || existingExercise?.instructions,
            tips: exercise.tips || existingExercise?.tips,
            commonMistakes: exercise.commonMistakes || existingExercise?.commonMistakes,
          };
        }));
      }
      setCurrent_exercise_ind(data.progress || 0);
      setExpectedExerciseLength(data.expected_exercise_length ?? (Array.isArray(data.exercises) ? data.exercises.length : null));
      setAllowedSessions(data.allowed_sessions || allowedSessions);
      setSessionsToday(data.sessions_today || sessionsToday);
      setSessionFeedbackRequired(data.sessionFeedbackRequired || false);
      // move into education flow after starting
      setPlayingState("education");
    } catch (err) {
      console.error(err);
      alert("Error starting session");
    }
  };

  // Fetch all sessions for the diagnosis (used to compute aggregated compliance)
  const fetchAllSessions = async (diagnosisIdentifier, treatmentId) => {
    const tid = treatmentId || treatmentIdProp || treatmentIdState;
    console.log('[TreatmentSessionPlayer] Fetching all sessions for treatment:', tid);
    
    try {
      let res;
      if (tid) {
        // Use treatment-based endpoint
        res = await fetch(`https://api.virtus-one.com/treatment/sessions/all/treatment/${tid}/`, {
          headers: { "Authorization": `Token ${token}` },
          method: 'GET'
        });
      } else {
        // Fallback to diagnosis-based
        res = await fetch(`https://api.virtus-one.com/treatment/sessions/all/${diagnosisIdentifier}/`, {
          headers: { "Authorization": `Token ${token}` },
          method: 'GET'
        });
      }
      
      if (!res.ok) return null;
      const json = await res.json();
      // console.log('[TreatmentSessionPlayer] All sessions data:', json);
      
      const mapped = (json.sessions || []).map(session => ({
        id: session.id,
        completed_date: session.completed_date,
        phase: session.phase,
        phase_index: session.phase_index,
        exercise_feedback: session.exercise_feedback,
        session_feedback: session.session_feedback,
      }));
      setCompletedSessionsAll(mapped);
      const historicalFeedbackIds = {};
      mapped.forEach(session => {
        (session.exercise_feedback || []).forEach(feedback => {
          if (feedback.exercise_id && feedback.id) {
            historicalFeedbackIds[feedback.exercise_id] = feedback.id;
          }
        });
      });
      setFeedbackIds(currentIds => ({ ...historicalFeedbackIds, ...currentIds }));

      // prefer server-provided planned_sessions_per_day_overall when available
      const planned = (typeof json.planned_sessions_per_day_overall === 'number' && json.planned_sessions_per_day_overall > 0)
        ? Number(json.planned_sessions_per_day_overall)
        : (allowedSessions || 3);

      // compute aggregated compliance (overall + last 7 days)
      const counts = {};
      let minDate = null; let maxDate = null;
      mapped.forEach(s => {
        if (s && s.completed_date) {
          const d = new Date(s.completed_date);
          if (isNaN(d)) return;
          const k = d.toISOString().slice(0,10);
          counts[k] = (counts[k] || 0) + 1;
          if (!minDate || d < minDate) minDate = d;
          if (!maxDate || d > maxDate) maxDate = d;
        }
      });
      const today = new Date();
      const totalDays = minDate ? (Math.floor((new Date(today).setHours(0,0,0,0) - new Date(minDate).setHours(0,0,0,0)) / 86400000) + 1) : 1;
      const totalCompleted = Object.values(counts).reduce((a,b) => a + b, 0);
      const totalPlanned = Math.max(1, totalDays * planned);
      const overallPct = Math.round(Math.min(100, (totalCompleted / totalPlanned) * 100));

      let last7Completed = 0;
      for (let i = 0; i < 7; i++) {
        const d = new Date();
        d.setDate((new Date()).getDate() - i);
        const key = d.toISOString().slice(0,10);
        last7Completed += counts[key] || 0;
      }
      const last7Planned = Math.max(1, planned * 7);
      const last7Pct = Math.round(Math.min(100, (last7Completed / last7Planned) * 100));

      setAvgCompliance(overallPct);
      setAvgAdherenceLast7(last7Pct);
      return mapped;
    } catch (err) {
      console.error('fetchAllSessions failed', err);
      return null;
    }
  };
  
  useEffect(() => {
    const treatmentId = treatmentIdProp || treatmentIdState;
    if (!treatmentId || initializedTreatmentIdRef.current === treatmentId) return;
    initializedTreatmentIdRef.current = treatmentId;
    fetchDiagnosisData();
    
  }, [treatmentIdProp, treatmentIdState])

  // Auto-end session when user disengages (navigates away, closes tab, logs out, etc.)
  useEffect(() => {
    const handleBeforeUnload = () => {
      // Call backend to explicitly end session on disengagement
      if (sessionId && token) {
        // Use sendBeacon for reliability (survives page unload)
        const payload = JSON.stringify({});
        navigator.sendBeacon(
          `https://api.virtus-one.com/treatment/session/end/${sessionId}/`,
          new Blob([payload], { type: 'application/json' })
        );
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [sessionId, token]);

  const toggleFullScreen = () => {
    screenfull.toggle(containerRef.current)
  }

  const onFeedbackConfirm = () => {
    setCurrent_exercise_ind(current => current + 1);
    if (playerRef.current && typeof playerRef.current.restart === "function") {
      playerRef.current.restart();
    }
  };

  const currentExercise = exercises[current_exercise_ind];
  const currentExternalSource = String(currentExercise?.source || '').toLowerCase();
  const currentExternalExerciseId = currentExercise?.sourceExerciseId;
  useEffect(() => {
    const source = currentExternalSource;
    const sourceExerciseId = currentExternalExerciseId;
    if (!source || !sourceExerciseId || !['ascend', 'musclewiki'].includes(source) || currentExercise?.video) return undefined;

    const cacheKey = `${source}:${sourceExerciseId}`;
    const cachedExercise = externalExerciseCacheRef.current[cacheKey];
    let cancelled = false;

    const applyExternalContent = (content) => {
      if (cancelled || !content) return;
      externalExerciseCacheRef.current[cacheKey] = content;
      setExercises(currentExercises => currentExercises.map((currentExercise, index) => (
        index === current_exercise_ind
          ? {
              ...currentExercise,
              title: content.title || currentExercise.title,
              description: content.description || currentExercise.description,
              exerciseType: content.exerciseType || currentExercise.exerciseType,
              exerciseLevel: content.exerciseLevel ?? currentExercise.exerciseLevel,
              equipment: content.equipment || currentExercise.equipment,
              bodyRegion: content.bodyRegion || currentExercise.bodyRegion,
              img: content.pictureURL || currentExercise.img,
              video: content.videoURL || currentExercise.video,
              instructions: content.instructions || currentExercise.instructions,
              tips: content.tips || currentExercise.tips,
              commonMistakes: content.commonMistakes || currentExercise.commonMistakes,
              variations: content.variations || currentExercise.variations,
              externalContentUnavailable: false,
            }
          : currentExercise
      )));
    };

    if (cachedExercise) {
      applyExternalContent(cachedExercise);
      return () => { cancelled = true; };
    }

    const loadExternalExercise = async () => {
      try {
        const detailResponse = await fetch(
          `https://api.virtus-one.com/treatment/external-exercises/${source}/${sourceExerciseId}/`,
          { headers: { Authorization: `Token ${token}` }, method: 'GET' }
        );
        if (!detailResponse.ok) return;
        const detail = await detailResponse.json();
        let media = {};
        if (source === 'musclewiki') {
          const mediaResponse = await fetch(
            `https://api.virtus-one.com/treatment/external-exercises/musclewiki/${sourceExerciseId}/media/`,
            { headers: { Authorization: `Token ${token}` }, method: 'GET' }
          );
          if (mediaResponse.ok) media = await mediaResponse.json();
        }
        applyExternalContent({ ...detail, ...media });
      } catch (error) {
        console.warn('[TreatmentSessionPlayer] Unable to refresh external exercise content:', error);
      }
    };

    loadExternalExercise();
    return () => { cancelled = true; };
  }, [current_exercise_ind, currentExternalExerciseId, currentExternalSource, token]);

  const handleSessionFeedbackComplete = () => {
    // Navigate to the physiotherapeutic plan page after session feedback
    // to avoid re-loading and re-rendering the exercises that were just completed.
    // This avoids the conflict observed when the frontend re-fetches and
    // displays the same exercises immediately after feedback submission.
    window.location.href = '/physiotherapeutic_plan';
  };

  // OLD method that bugged - left for reference - and to test if needed later
  {/*const handleSessionFeedbackComplete = () => {
    (async () => {
      try {
        const data = await fetchExercises(diagnosis.identifier);
        // If all sessions for today are complete, refresh/redirect to the plan page
        if (data && (data.allDailySessionsComplete || data.sessionFeedbackRequired === false)) {
          // force full page navigation to re-render the plan components (normalizes state)
          window.location.href = '/physiotherapeutic_plan';
        }
      } catch (err) {
        console.error(err);
      }
    })();
  };*/}

  useEffect(() => {
    if (allDailySessionsComplete) {
      setPlayingState("done_for_today");
    } else if (allDailySessionsPartlyCompleted) {
      setPlayingState("daily_Session_Partly_Complete");
    } else if (first_today) {
      setPlayingState("welcome");
    }
  }, [allDailySessionsComplete, allDailySessionsPartlyCompleted, first_today]);
  
  useEffect(() => {
    if (playingState !== "video") {
      setVideoIsPlaying(false);
      if (playerRef.current && typeof playerRef.current.pausePlaying === "function") {
        playerRef.current.pausePlaying();
      }
    }
  }, [playingState]);

  // Accept drawerOpen and setDrawerOpen from props, default to undefined if not provided
  const { drawerOpen, setDrawerOpen } = props || {};

  // Compute a responsive minHeight that respects viewport and layout.
  // Reduced multiplier to make the video area roughly ~10vh shorter on typical viewports
  // while maintaining reasonable minimums for usability.
  const minVideoAreaHeight = Math.min(Math.max(window.innerHeight * 0.35, 300), 700); // between 300 and 700 px, ~35% of viewport

  return (
    <div style={{ width: '100%', margin: 0 }} >
    {/* Show completed session if all sessions are done */}
    {allDailySessionsComplete ? (         
         <CompletedSession 
           progress={phaseData.progress}
           title={phaseData.title}
           phaseProgressDisplay={phaseData.progressDisplay}
           sessionsToday={sessionsToday}
           allowedSessions={allowedSessions}
           completedSessionsList={completedSessionsList}
           avgCompliance={avgCompliance}
           avgAdherenceLast7={avgAdherenceLast7}
           completedSessions={completedSessionsTodayWithFeedback}
           setDrawerOpen={false}
         />
      ) : playingState === "daily_Session_Partly_Complete" ? (
        <CompletedSessionPartly
          progress={phaseData.progress}
          title={phaseData.title}
          phaseProgressDisplay={phaseData.progressDisplay}
          onStart={async () => {
            await startSession();
            if (setDrawerOpen) setDrawerOpen(false); // Close drawer on start
          }}
          exercisesPlanned={exercises.length}
          sessionsToday={sessionsToday}
          allowedSessions={allowedSessions}
          completedSessionsList={completedSessionsList}
          avgCompliance={avgCompliance}
          avgAdherenceLast7={avgAdherenceLast7}
        />
      ) : playingState === "welcome" ? (
        <WelcomeScreen xs={12}
          progress={phaseData.progress}
          title={phaseData.title}
          phaseProgressDisplay={phaseData.progressDisplay}
          exercisesPlanned={exercises.length}
          sessionsToday={sessionsToday}
          allowedSessions={allowedSessions}
          equipmentList={equipmentList}
          avgCompliance={avgCompliance}
          avgAdherenceLast7={avgAdherenceLast7}
          onStart={async () => {
            await startSession();
            if (setDrawerOpen) setDrawerOpen(false); // Close drawer on start
          }}
        />
      ) : <Grid container xs={12} direction="row" style={{ height: '100vh', width: 'auto'}}>
          <Grid container ref={containerRef} xs={12} sm={12} md={8} lg={9} style={{ marginTop: 0, paddingLeft: 0, paddingRight: 0, position: "relative", background: "#000", borderRadius: 'clamp(8px, 0.9vw, 12px)', boxShadow: "0 4px 16px rgba(0,45,85,0.10)", minHeight: minVideoAreaHeight, maxHeight: '76vh' }}>
            {exercises.length > 0 && exercises[current_exercise_ind] && (
            <FeedbackCompPopOver
              open={playingState === "feedback"}
              id="popover"
              handleClose={() => setPlayingState("education")}
              anchor={feedbackRef}
              container={containerRef}
              exercise={exercises[current_exercise_ind]}
              onFeedbackConfirm={onFeedbackConfirm}
              onSessionFeedbackComplete={handleSessionFeedbackComplete}
              diagnosis={diagnosis}
              isLastExercise={current_exercise_ind + 1 === exercises.length}
              allExercises={exercises}
              sessionId={sessionId}
              treatmentId={treatmentIdState}
              feedbackIds={feedbackIds}
              onFeedbackSubmitted={recordFeedbackId}
              expectedExerciseLength={expectedExerciseLength}
            />
            )}
            {exercises.length > 0 && exercises[current_exercise_ind] && (
            <ExerciseIntro
              currentExerciseIndex={current_exercise_ind}
              totalExercises={exercises.length}
              open={playingState === "education"}
              id="popoverEducation"
              handleClose={() => {
                setVideoIsPlaying(false);
                setTimeout(() => {
                  setVideoIsPlaying(true);
                  setPlayingState("video");
                  if (playerRef.current && typeof playerRef.current.resumePlaying === "function") {
                    playerRef.current.resumePlaying();
                  }
                }, 0);
              }}
              anchor={educationRef}
              container={containerRef}
              exercise={exercises[current_exercise_ind]}
              onFeedbackConfirm={onFeedbackConfirm}
              onSkip={() => {
                setVideoIsPlaying(false);
                if (playerRef.current && typeof playerRef.current.pause === "function") {
                  playerRef.current.pausePlaying();
                }
                setPlayingState("");
                setTimeout(() => setPlayingState("feedback"), 0);
              }}
              diagnosis={diagnosis}
              anchorPosition={{ top: window.innerHeight / 2, left: window.innerWidth / 2 }}
            />
            )}
            <VideoPlayer
              ref={playerRef}
              isPlaying={videoIsPlaying}
              onPlayPauseClick={handlePlayPause}
              onFullScreen={toggleFullScreen}
              containerRef={containerRef}
              // allow VideoPlayer to pick up the computed minimum height
              minHeight={minVideoAreaHeight}
              exercise={exercises[current_exercise_ind]} 
              goToFeedback={(e) => {
                handleStateShift("feedback")
                setFeedbackRef(e.currentTarget)
              }}
              goToEducation={(e) => {
                handleStateShift("education")
                setEducationRef(e.currentTarget)
              }}
              nextExercises={exercises.map((exerciseObj, ind) => ({
                ...exerciseObj,
                completed: ind < current_exercise_ind
              }))}
            />
          </Grid>
          <Grid container xs={12} sm={12} md={4} lg={3} direction="row" className={classes.sidebarGrid}>
            <Grid item style={{ width: '100%' }}>
              <NextExercises
                currentExerciseIndex={current_exercise_ind}
                totalExercises={exercises.length}
                exercise={exercises[current_exercise_ind]} 
                nextExercises={exercises.map((exerciseObj, ind) => {
                  return {
                    ...exerciseObj,
                    completed: ind < current_exercise_ind
                  }
                })}
                  goToFeedback={() => {
                    // reuse the same handler the VideoPlayer uses to open feedback
                    setPlayingState("feedback");
                    // ensure focus/anchor behavior is handled by VideoPlayer flow where needed
                  }}
                
              />
            </Grid>
          </Grid>
        </Grid> }
      </div>
  )
};


export default TreatmentSessionPlayer;
